import { Facebook, Twitter, Linkedin, Link as LinkIcon } from "lucide-react";
import { toast } from "sonner";

// Social share buttons — opens native share windows for major platforms.
export default function ShareButtons({ url, title }) {
    const encodedUrl = encodeURIComponent(url);
    const encodedTitle = encodeURIComponent(title);

    const shares = [
        {
            name: "Facebook",
            icon: Facebook,
            href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
            color: "hover:bg-[#1877F2] hover:text-white",
        },
        {
            name: "Twitter",
            icon: Twitter,
            href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
            color: "hover:bg-[#1DA1F2] hover:text-white",
        },
        {
            name: "LinkedIn",
            icon: Linkedin,
            href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
            color: "hover:bg-[#0A66C2] hover:text-white",
        },
    ];

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(url);
            toast.success("Lien copié !");
        } catch {
            toast.error("Impossible de copier");
        }
    };

    return (
        <div data-testid="share-buttons" className="flex items-center gap-2">
            <span className="text-xs uppercase tracking-[0.2em] text-[#6E6862] mr-2">
                Partager
            </span>
            {shares.map((s) => (
                <a
                    key={s.name}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`share-${s.name.toLowerCase()}`}
                    aria-label={`Partager sur ${s.name}`}
                    className={`w-10 h-10 rounded-full border border-[#E8E2D9] bg-white flex items-center justify-center transition-all ${s.color}`}
                >
                    <s.icon size={16} />
                </a>
            ))}
            <button
                type="button"
                onClick={copyLink}
                data-testid="share-copy-link"
                aria-label="Copier le lien"
                className="w-10 h-10 rounded-full border border-[#E8E2D9] bg-white flex items-center justify-center transition-all hover:bg-[#3D8C95] hover:text-white"
            >
                <LinkIcon size={16} />
            </button>
        </div>
    );
}
